import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-appointment',
  templateUrl: './skeleton-appointment.component.html',
  styleUrls: ['./skeleton-appointment.component.scss']
})
export class SkeletonAppointmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
